import React, {useEffect} from 'react';
import "./HeroRight.css";

import AOS from "aos";
import "aos/dist/aos.css";


function HeroRight() {


    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="hero-right" data-aos={"fade"} data-aos-delay="1500">
            <div className="hero-right-mail">
                <a href="subhampreet18@gmail.com">subhampreet18@gmail.com</a>
            </div>
        </div>
    )
}

export default HeroRight

